import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  try {
    Sentry.init({
      dsn: sentryDsn,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0.1,
    });
  } catch (e) {
    console.warn("Sentry init failed", e);
  }
}

// Global error handler for debugging white screens in production
if (typeof window !== 'undefined') {
  window.onerror = (message, source, lineno, colno, error) => {
    console.error("Global Error:", message, error);
    // If we have a white screen, try to show the error
    const root = document.getElementById("root");
    if (root && root.innerHTML === "") {
      root.innerHTML = `
        <div style="padding: 20px; color: white; background: #0a0a0b; font-family: sans-serif;">
          <h1 style="color: #ff4400;">Application Error</h1>
          <p>The application crashed during initialization.</p>
          <pre style="background: #1a1a1b; padding: 10px; border-radius: 8px; overflow: auto;">${message}
${error?.stack || ''}</pre>
          <button onclick="window.location.reload()" style="background: #ff4400; color: white; border: none; padding: 10px 20px; border-radius: 5px; cursor: pointer;">Reload Page</button>
        </div>
      `;
    }
  };

  window.onunhandledrejection = (event) => {
    console.error("Unhandled Rejection:", event.reason);
  };
}

const app = sentryDsn ? (
  <Sentry.ErrorBoundary fallback={<div className="p-10 text-white">Something went wrong. Please refresh.</div>}>
    <App />
  </Sentry.ErrorBoundary>
) : (
  <App />
);

const container = document.getElementById("root");
if (container) {
  createRoot(container).render(app);
}